import { Button, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { modalsToggle } from 'actions';
import { formatCurrency } from 'utils';
import { Vehicle } from 'types/vehicle';
import { BuyNowModal } from 'pages/Buyer/BidsList/components/BuyNowModal';
import { SectionDivider } from 'pages/Shared/VehicleDetails/components';

const AcceptButton = styled(Button)`
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 44px;
  cursor: pointer;
  background: #225a91;
  color: #fff;

  &:hover {
    background: #225a91;
  }

  @media (max-width: 960px) {
    width: 100%;
    margin-top: 8px;
  }
`;

type Props = {
  vehicle: Vehicle;
  includeDivider: boolean;
};

export const BuyNowSection = ({ vehicle, includeDivider }: Props) => {
  const dispatch = useDispatch();

  if (vehicle.in_battle || !vehicle.active_alternative_offer) return null;

  const handleAccept = () => dispatch(modalsToggle(`buyNowModal-${vehicle.id}`));

  return (
    <>
      {includeDivider && <SectionDivider />}
      <Grid container justify="space-between" alignItems="center">
        <AcceptButton onClick={handleAccept}>{`Buy now for ${formatCurrency(
          vehicle.active_alternative_offer.amount
        )}`}</AcceptButton>
        <BuyNowModal currentVehicle={vehicle} />
      </Grid>
    </>
  );
};
